module.exports = __webpack_public_path__ + "img/id.6e53f859.png";